module.exports = __webpack_public_path__ + "media/application/images/company/founders/Gordon-Stove-3bb6b830905e457eb1162ac5e7ffca67.jpg";